export default __webpack_public_path__ + "139aa88f55f28d7facc1791c6a8c1b29.png";